import moment from 'moment';
import { DateFromat } from '../../utils/dateFormat';
import BaseDomainService from "./baseDomainServices";

const contactUsList = {
    searchText: ""
}

export default class contactUsServices extends BaseDomainService {

    //** API Get
    getList = this.apiService.contactUsService.admin_GetContactUsList;
    getById = this.apiService.contactUsService.admin_GetContactUsById;

    //** Table Grid columns
    gridColmns = [
        { name: 'fullName', title: 'Name' },
        { name: 'emailAddress', title: 'Email Address' },
        { name: 'createdDate', title: 'Date Time' },
        { name: 'contactUsId', title: 'View Detail' },
    ];

    //** Define the state variables
    dataItem;

    //** Define the form fields
    formFields = [
        {
            inputType: "search",
            placeholder: "Search ...",
            fieldName: "searchText",
            labelStyleName: 'none',
            className: 'ms-auto relative search-bar-input'
        },
        {
            inputType: "label",
            tittle: "Name :",
            fieldName: "fullName",
            labelClass: 'text-x leading-snug text-slate-500 font-bold'
        },
        {
            inputType: "label",
            tittle: "Email Address :",
            fieldName: "emailAddress",
            labelClass: 'text-x leading-snug text-slate-500 font-bold'
        },
        {
            inputType: "label",
            tittle: "Phone No :",
            fieldName: "phone",
            labelClass: 'text-x leading-snug text-slate-500 font-bold'
        },
        {
            inputType: "label",
            tittle: " Company Name :",
            fieldName: "company",
            labelClass: 'text-x leading-snug text-slate-500 font-bold'
        },
        {
            inputType: "label",
            tittle: " Product Name :",
            fieldName: "productName",
            labelClass: 'text-x leading-snug text-slate-500 font-bold'
        },
        {
            inputType: "label",
            tittle: "Message :",
            fieldName: "message",
            labelClass: 'text-x leading-snug text-slate-500 font-bold'
        },
    ]

    //** Constructor 
    constructor() {
        super();
        this.onPaginationUpdate = this.onGetContactUs.bind(this);
        this.actionKey = "contactUsId";
        this.dataItem = { ...contactUsList };
    }

    //** API Calls
    onGetContactUs = (requst) => {
        this.apiService.onAPICall("getContactUs", this.getList, requst, this.onAPIResponse, this.onUpdateState);
    }
    onGetById = (requst) => {
        this.apiService.onAPICall("getById", this.getById, requst, this.onAPIResponse, this.onUpdateState);
    }

    //** Redirect To
    redirectToListPage = () => {
        var contactUrl = localStorage.getItem('ContactUrl');
        if (contactUrl != null) {
            this.onRedirect("/")
            localStorage.clear();
        }
        else {
            this.onRedirect("/ContactUsList")
        }
    }

    //** Response Method
    onAPIResponse = (key, isSuccess, responseData) => {
        if (!isSuccess) {
            this.onUpdateState({ "setIsLoad": false });
            return;
        }
        switch (key) {
            case "getContactUs":
                if (responseData.itemList !== null) {
                    let itemList = responseData.itemList;
                    itemList.forEach(function (i) {
                        i.productName = i.productName ? i.productName : "-";
                        i.createdDate = i.createdDate ? DateFromat(i.createdDate) : '-'        //h:mm a  .... for time format
                    })
                    this.onUpdateState({
                        dataList: responseData.itemList,
                        TotalCount: responseData.totalCount,
                        setIsLoad: false
                    });
                }
                break;
            case "getById":
                let contactDet = ({ ...responseData });
                this.dataItem = { ...contactDet };
                this.onUpdateState({
                    getContactDetails: {
                        fullName: contactDet.fullName,
                        emailAddress: contactDet.emailAddress,
                        phone: contactDet.phone,
                        company: contactDet.company,
                        productName: contactDet.productName,
                        message: contactDet.message
                    },
                    "setIsLoad": false
                });
                break;
        }
    }
}

